import { useCan, useIfUser } from '@if/mui'
import { access } from '@src/access'
import { useMerchant } from '@src/containers/App/MerchantProvider'
import { useMerchantByParentId } from '@src/data/api/merchants-api/merchants-api'

/**
 * Whether the current user may invite an applicant. A thin dispatcher over the
 * shared access rules: standard users are gated on their own merchant's programs
 * (`inviteApplicant`), banner users on the rollout switch and their subsidiaries'
 * programs (`bannerInvitations`) — never the banner entity's own. Shared by the
 * sidebar action, the applications-page header and the home hero so the gate can't
 * drift.
 */
export const useCanInviteApplicant = (): boolean => {
  const user = useIfUser()
  const merchant = useMerchant()
  const [subsidiaries] = useMerchantByParentId(user.isBannerUser ? user.merchantId : '')

  const canInviteStandard = useCan(access.inviteApplicant, { merchant })
  const canInviteBanner = useCan(access.bannerInvitations, {
    subsidiaries: subsidiaries ?? [],
    company: merchant.financingCompanyId,
  })

  return user.isBannerUser ? canInviteBanner : canInviteStandard
}
